import {
  createContext,
  useContext,
  useEffect,
  useState,
  ReactNode,
} from "react";
import LoadingBrand from "./branding-assets/LoadingBrand";

interface BrandingConfig {
  companyName: string;
  companyNameShort: string;
  logo: string;
  logoWhite: string;
  title: string;
  footerCopyright: string;
  footerPoweredBy: string;
  privacyPolicyUrl: string;//CS-1602
  termsAndConditionsUrl: string;//CS-1602
  favicon: string;
  logoIcon: string;
  logoIconWhite: string;
  welcomeMessage: any;
  practiceContactInformation: any;
  supportContactInformation: any;
}

const brand = process.env.REACT_APP_BRAND || "mpm";

const BrandingContext = createContext<BrandingConfig | null>(null);

export const useBranding = () => useContext(BrandingContext);

export const BrandingProvider = ({ children }: { children: ReactNode }) => {
  const [branding, setBranding] = useState<BrandingConfig | null>(null);

  useEffect(() => {
    let isMounted = true; // CS-1984: guard side-effects/setState against an unmount mid-fetch
    const loadConfig = async () => {
      try {
        const res = await fetch("/branding/config.json");
        if (!res.ok)
          throw new Error(`Could not load config for brand: ${brand}`);
        const config = await res.json();

        if (!isMounted) return; // CS-1984: provider unmounted before the fetch resolved → ignore the stale response

        // Set favicon with cache-busting
        const favicon = document.getElementById("favicon") as HTMLLinkElement;
        if (favicon && config.favicon) {
          favicon.href = `${config.favicon}?v=${Date.now()}`;
        }

        // Set document title
        if (config.title) {
          document.title = config.title;
        }

        setBranding(config);
      } catch (error) {
        console.error("Error loading branding config:", error);
      }
    };

    loadConfig();
    return () => {
      isMounted = false; // CS-1984: cleanup — marks the in-flight request as abandoned
    };
  }, []);

  // Show loading spinner until branding is loaded
  if (!branding) {
  return (
    <LoadingBrand/>
  );
}


  return (
    <BrandingContext.Provider value={branding}>
      {children}
    </BrandingContext.Provider>
  );
};
